"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Orbus Artwork Uploader
 * Artwork uploader, PDF preflight queue & processor.  Please refer to the [AWS Developer Guide](https://docs.aws.amazon.com/AmazonS3/latest/dev/UsingRESTAPImpUpload.html) for multipart uploads.  The upload-related methods do not take file data themselves, rather they act as helper methods for using the AWS S3 APIs.  It is strongly recommended that you use Uppy and its [AWS S3 Multipart plugin](https://uppy.io/docs/aws-s3-multipart/) to assist with uploading files. The provided demo/example code offers a functioning example.
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DownloadApi = void 0;
const runtime = require("../runtime");
/**
 * no description
 */
class DownloadApi extends runtime.BaseAPI {
    /**
     * Get original artwork file.
     */
    downloadOriginalPdfRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.jobId === null || requestParameters.jobId === undefined) {
                throw new runtime.RequiredError('jobId', 'Required parameter requestParameters.jobId was null or undefined when calling downloadOriginalPdf.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/download/{jobId}/original.pdf`.replace(`{${"jobId"}}`, encodeURIComponent(String(requestParameters.jobId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Get original artwork file.
     */
    downloadOriginalPdf(jobId) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.downloadOriginalPdfRaw({ jobId: jobId });
        });
    }
    /**
     * Get pdftoolbox generated output JSON.
     */
    downloadOutputJsonRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.jobId === null || requestParameters.jobId === undefined) {
                throw new runtime.RequiredError('jobId', 'Required parameter requestParameters.jobId was null or undefined when calling downloadOutputJson.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/download/{jobId}/output.json`.replace(`{${"jobId"}}`, encodeURIComponent(String(requestParameters.jobId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Get pdftoolbox generated output JSON.
     */
    downloadOutputJson(jobId) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.downloadOutputJsonRaw({ jobId: jobId });
        });
    }
    /**
     * Get pdftoolbox generated output pdf.
     */
    downloadOutputPdfRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.jobId === null || requestParameters.jobId === undefined) {
                throw new runtime.RequiredError('jobId', 'Required parameter requestParameters.jobId was null or undefined when calling downloadOutputPdf.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/download/{jobId}/output.pdf`.replace(`{${"jobId"}}`, encodeURIComponent(String(requestParameters.jobId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Get pdftoolbox generated output pdf.
     */
    downloadOutputPdf(jobId) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.downloadOutputPdfRaw({ jobId: jobId });
        });
    }
    /**
     * Get generated report json.
     */
    downloadReportJsonRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.jobId === null || requestParameters.jobId === undefined) {
                throw new runtime.RequiredError('jobId', 'Required parameter requestParameters.jobId was null or undefined when calling downloadReportJson.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/download/{jobId}/report.json`.replace(`{${"jobId"}}`, encodeURIComponent(String(requestParameters.jobId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Get generated report json.
     */
    downloadReportJson(jobId) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.downloadReportJsonRaw({ jobId: jobId });
        });
    }
    /**
     * Get pdftoolbox report pdf.
     */
    downloadReportPdfRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.jobId === null || requestParameters.jobId === undefined) {
                throw new runtime.RequiredError('jobId', 'Required parameter requestParameters.jobId was null or undefined when calling downloadReportPdf.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/download/{jobId}/report.pdf`.replace(`{${"jobId"}}`, encodeURIComponent(String(requestParameters.jobId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Get pdftoolbox report pdf.
     */
    downloadReportPdf(jobId) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.downloadReportPdfRaw({ jobId: jobId });
        });
    }
    /**
     * Get pdftoolbox report xml.
     */
    downloadReportXmlRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.jobId === null || requestParameters.jobId === undefined) {
                throw new runtime.RequiredError('jobId', 'Required parameter requestParameters.jobId was null or undefined when calling downloadReportXml.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/download/{jobId}/report.xml`.replace(`{${"jobId"}}`, encodeURIComponent(String(requestParameters.jobId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Get pdftoolbox report xml.
     */
    downloadReportXml(jobId) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.downloadReportXmlRaw({ jobId: jobId });
        });
    }
    /**
     * Get share thumbnail.
     */
    downloadShareThumbnailRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.jobId === null || requestParameters.jobId === undefined) {
                throw new runtime.RequiredError('jobId', 'Required parameter requestParameters.jobId was null or undefined when calling downloadShareThumbnail.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/download/{jobId}/thumbnails/1-fit.png`.replace(`{${"jobId"}}`, encodeURIComponent(String(requestParameters.jobId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Get share thumbnail.
     */
    downloadShareThumbnail(jobId) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.downloadShareThumbnailRaw({ jobId: jobId });
        });
    }
    /**
     * Get simplified report json.
     */
    downloadSimpleReportJsonRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.jobId === null || requestParameters.jobId === undefined) {
                throw new runtime.RequiredError('jobId', 'Required parameter requestParameters.jobId was null or undefined when calling downloadSimpleReportJson.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/download/{jobId}/report.simple.json`.replace(`{${"jobId"}}`, encodeURIComponent(String(requestParameters.jobId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Get simplified report json.
     */
    downloadSimpleReportJson(jobId) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.downloadSimpleReportJsonRaw({ jobId: jobId });
        });
    }
    /**
     * Get an artwork thumbnail.
     */
    downloadThumbnailRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.jobId === null || requestParameters.jobId === undefined) {
                throw new runtime.RequiredError('jobId', 'Required parameter requestParameters.jobId was null or undefined when calling downloadThumbnail.');
            }
            if (requestParameters.pageNumber === null || requestParameters.pageNumber === undefined) {
                throw new runtime.RequiredError('pageNumber', 'Required parameter requestParameters.pageNumber was null or undefined when calling downloadThumbnail.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/download/{jobId}/thumbnails/{pageNumber}.png`.replace(`{${"jobId"}}`, encodeURIComponent(String(requestParameters.jobId))).replace(`{${"pageNumber"}}`, encodeURIComponent(String(requestParameters.pageNumber))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Get an artwork thumbnail.
     */
    downloadThumbnail(jobId, pageNumber) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.downloadThumbnailRaw({ jobId: jobId, pageNumber: pageNumber });
        });
    }
    /**
     * Get a range of artwork thumbnail URLs
     */
    getThumbnailRangeRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.jobId === null || requestParameters.jobId === undefined) {
                throw new runtime.RequiredError('jobId', 'Required parameter requestParameters.jobId was null or undefined when calling getThumbnailRange.');
            }
            const queryParameters = {};
            if (requestParameters.startPage !== undefined) {
                queryParameters['startPage'] = requestParameters.startPage;
            }
            if (requestParameters.endPage !== undefined) {
                queryParameters['endPage'] = requestParameters.endPage;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/download/{jobId}/thumbnails`.replace(`{${"jobId"}}`, encodeURIComponent(String(requestParameters.jobId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Get a range of artwork thumbnail URLs
     */
    getThumbnailRange(jobId, startPage, endPage) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.getThumbnailRangeRaw({ jobId: jobId, startPage: startPage, endPage: endPage });
        });
    }
}
exports.DownloadApi = DownloadApi;
